<template>
  <Cascader
    v-if="type=='citySelect'"
    v-model="curentValue"
    :data="data"
    :placeholder="placeholder"
    trigger="hover"
    @on-change="onChange"
  ></Cascader>
  <div v-else>
    <span
      v-for="(item,index) in curentValue"
      :key="index"
      style="margin-right: 5px"
    >{{ obj[item] }}</span>
  </div>
</template>

<script>
export default {
  name: 'CitySelect',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      type: String,
      default: 'citySelect',
    },
    placeholder: {
      type: String,
      default: '请选择省市区',
    },
  },
  data() {
    return {
      data: [
      ],
      obj: {},
      curentValue: this.value,
    };
  },
  watch: {
    value: {
      handler() {
        this.curentValue = this.value;
      },
    },
  },
  created() {
    this.getListAllProvince();
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
    getListAllProvince() {
      this.$store.dispatch('getCityData').then(res => {
        const { list, obj } = res;
        this.obj = obj;
        this.data = list;
      });
    },
  },
};
</script>

<style scoped>

</style>
